module.exports = __webpack_public_path__ + "media/images/coupon-is-here-3d1c21fcc6ffaa86326a26032d30b1b4.svg";